import React, { useEffect, useState } from 'react'

import SelectField from 'components/Common/SelectField'
import { AccountingCharts, DateRanges } from '../../../../__generated__/api-types-and-hooks'
import { chartRangeChanged, chartRangeViewed, getRoleFromPath, navigateTo } from 'utils/helper'
import { DateRangesNamesMap, IDataTabs, ROLES } from 'config'
import moment from 'moment'
import { AppGrowingContainer } from 'components/Common/AppGrowingContainer/AppGrowingContainer.component'
import { AppPageHeading } from 'components/AppDataReport/AppData/AppData.style'
import { AppProfitAndLossChart } from 'components/AppDataReport/AppData/AppFinance/AppProfitAndLoss.component'
import { AppLiquidCashChart } from 'components/AppDataReport/AppData/AppFinance/AppLiquidCash.component'

const getDateByDateRange = (filter: string) => {
  let startDate: string = ''
  let endDate: string = ''

  switch (filter) {
    case DateRanges.ThisMonth:
      startDate = moment().startOf('month').format('YYYY-MM-DD')
      endDate = moment().endOf('month').format('YYYY-MM-DD')
      break
    case DateRanges.ThisQuarter:
      startDate = moment().startOf('quarter').format('YYYY-MM-DD')
      endDate = moment().endOf('quarter').format('YYYY-MM-DD')
      break
    case DateRanges.Last12Months:
      startDate = moment().subtract(12, 'months').startOf('month').format('YYYY-MM-DD')
      endDate = moment().endOf('month').format('YYYY-MM-DD')
      break
    case DateRanges.ThisYearToDate:
      startDate = moment().startOf('year').format('YYYY-MM-DD')
      endDate = moment().format('YYYY-MM-DD')
      break
    default:
      break
  }

  return { startDate, endDate }
}

export const AppFinance = ({ isLoading, financeData, getFinanceDataAction }) => {
  const [dateRange, setDateRange] = useState(DateRanges.ThisMonth)

  useEffect(() => {
    getFinanceDataAction()
  }, [getFinanceDataAction])

  const handleChange = (selectedDateRange: DateRanges) => {
    setDateRange(selectedDateRange)
    const { startDate, endDate } = getDateByDateRange(selectedDateRange)
    chartRangeChanged({
      section: IDataTabs.FINANCE,
      chartName: [AccountingCharts.ProfitAndLoss, AccountingCharts.LiquidCash],
      endDate,
      startDate,
    })
  }

  return (
    <AppGrowingContainer>
      <div className="grid col-span-12">
        <div className="flex flex-col sm:flex-row  justify-between py-7 px-5">
          <div className="flex flex-col">
            <AppPageHeading>Finance</AppPageHeading>
            {getRoleFromPath() === ROLES.BUSINESS_OWNER && (
              <p className="leading-9 text-black mb-4 mt-4 font-primary">
                If you haven’t connected your QuickBooks account to our system, please visit{' '}
                <span
                  className="text-primary hover:cursor-pointer"
                  onClick={() => navigateTo('', 'tools/featured')}
                >
                  Tools
                </span>
                .
              </p>
            )}
          </div>
          <div className="flex md:justify-end mb-6 mt-6 sm:mt-0">
            <SelectField
              label="FILTER BY TIME"
              placeholder="Select"
              isDropDownMenu={true}
              value={dateRange}
              customStyle={{
                control: {
                  backgroundColor: 'white',
                },
                container: {
                  borderRadius: '0.25rem',
                  minWidth: '300px',
                  border: '1px solid #D4D4D8',
                },
              }}
              name="dateRanges"
              options={Object.entries(DateRangesNamesMap).map(([key, value]) => ({
                label: value,
                value: key,
              }))}
              onChange={(selectedDateRange: DateRanges) => handleChange(selectedDateRange)}
              onMenuOpen={() => {
                chartRangeViewed({
                  section: IDataTabs.FINANCE,
                  chartName: [AccountingCharts.ProfitAndLoss, AccountingCharts.LiquidCash],
                })
              }}
            />
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="xs:col-span-12 md:col-span-4">
          <AppProfitAndLossChart period={dateRange} />
        </div>
        <div className="xs:col-span-12 md:col-span-4">
          <AppLiquidCashChart period={dateRange} />
        </div>
      </div>
    </AppGrowingContainer>
  )
}
